export default __webpack_public_path__ + "static/media/2.b43aa0f1.jpeg";